module.exports = __webpack_public_path__ + "static/itsm_capabilities_4-f19b5effadcb17a2ce62744767ad25cb.png";